import React from 'react';
import { generateTable } from '../../table/Table';
import { fetchForm } from '../../../apis';
import { defineFilter } from '../../../helpers';
var clientSide = defineFilter(true).startsWith('name', 'name').equals('status', 'status').equals('unique', 'unique').end(); // const indexStatuses = ['New', 'Building', 'Built', 'Failed'];

var BooleanYesNoCell = function BooleanYesNoCell(props) {
  return /*#__PURE__*/React.createElement("td", null, props.value ? 'Yes' : 'No');
};

var dataSource = function dataSource(_ref) {
  var formSlug = _ref.formSlug;
  return {
    fn: fetchForm,
    clientSide: clientSide,
    params: function params() {
      return [{
        datastore: true,
        kappSlug: null,
        formSlug: formSlug,
        include: 'indexDefinitions'
      }];
    },
    transform: function transform(result) {
      return {
        data: result.form.indexDefinitions
      };
    }
  };
}; // const filters = () => () => [
//   { name: 'name', label: 'Name', type: 'text' },
//   {
//     name: 'status',
//     label: 'Status',
//     type: 'select',
//     options: indexStatuses.map(el => ({ value: el, label: el })),
//   },
//   {
//     name: 'unique',
//     label: 'Unique',
//     type: 'select',
//     options: ['Yes', 'No'].map(el => ({ value: el, label: el })),
//   },
// ];


var columns = [{
  value: 'name',
  title: 'Name'
}, {
  value: 'status',
  title: 'Status'
}, {
  value: 'unique',
  title: 'Unique',
  components: {
    BodyCell: BooleanYesNoCell
  }
}, {
  value: 'parts',
  title: 'Parts'
}];
export var IndexDefinitionTable = generateTable({
  tableOptions: ['formSlug'],
  sortable: false,
  columns: columns,
  // filters,
  dataSource: dataSource
});
IndexDefinitionTable.displayName = 'IndexDefinitionTable';